/**
 * Construit l'URL deep-link PWA pour le QR code d'une œuvre.
 * Format canonique (contrat PWA ↔ admin) : {pwaUrlBase}/qr/{exhibitionId}/{workId}
 */
export function buildWorkQrUrl(
  pwaUrlBase: string,
  exhibitionId: string,
  workId: string,
): string {
  const base = pwaUrlBase.replace(/\/+$/, '');
  return `${base}/qr/${encodeURIComponent(exhibitionId)}/${encodeURIComponent(workId)}`;
}

export type WifiSecurityType = 'WPA' | 'WEP' | 'nopass';

export interface WifiQrOptions {
  ssid: string;
  password?: string;
  security?: WifiSecurityType;
  hidden?: boolean;
}

/**
 * Échappe les caractères spéciaux du format WIFI: (\, ;, ,, ", :)
 * @see https://github.com/zxing/zxing/wiki/Barcode-Contents#wi-fi-network-config-android-ios-11
 */
function escapeWifiField(value: string): string {
  return value.replace(/([\\;,":])/g, '\\$1');
}

/**
 * Construit le payload WIFI: pour un QR code de connexion automatique.
 * Format : WIFI:T:<security>;S:<ssid>;P:<password>;H:<hidden>;;
 */
export function buildWifiQrPayload({
  ssid,
  password = '',
  security = 'WPA',
  hidden = false,
}: WifiQrOptions): string {
  const trimmedSsid = ssid.trim();
  if (!trimmedSsid) {
    throw new Error('SSID is required');
  }

  const type = security === 'nopass' ? 'nopass' : security;
  const parts = [
    `T:${type}`,
    `S:${escapeWifiField(trimmedSsid)}`,
  ];

  if (type !== 'nopass') {
    parts.push(`P:${escapeWifiField(password)}`);
  }

  if (hidden) {
    parts.push('H:true');
  }

  return `WIFI:${parts.join(';')};;`;
}
